export var AmplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
            userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
            userPoolRegion: process.env.REACT_APP_COGNITO_REGION || '',
            loginWith: {
                oauth: {
                    domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
                    scopes: ['openid', 'profile', 'email'],
                    redirectSignIn: [process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || ''],
                    redirectSignOut: [process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || ''],
                    responseType: 'code',
                },
            },
        },
    },
};
